import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import { MainListItems, UserListItems } from '../SideNav/ListItems';
import useStyles from '../../assets/jss/layout-styles';

const SideDrawer = ({ user }) => {
  const router = useRouter();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const toggelDrawer = () => {
    setOpen(!open);
  };
  const handleClickAway = () => {
    setOpen(false);
  };

  useEffect(() => {
    router.events.on('routeChangeComplete', () => {
      setOpen(false);
    });
  }, [router])

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Drawer
        variant='permanent'
        classes={{ paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose) }}
        open={open}
        className='sideNav'
        onMouseOver={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={!open && toggelDrawer}
      >
        <div className={classes.logoIcon}>
          <img src='/NavLogo.png' title='Setting Scoliosis Straight' alt='SSSF Navigation Logo' />
        </div>
        <List>{user && <MainListItems user={user} />}</List>
        {/* <List>{secondaryListItems}</List> */}
        <List className='accountInfo'>{user && <UserListItems user={user} />}</List>
      </Drawer>
    </ClickAwayListener>
  );
};

export default SideDrawer;
